import React from 'react'
import LoveseatImage from '../../../../assets/products/sofa-2-seat-1-back.png'

const TwoSeatOneBack = ({ totalWidth = '' }) => {
  return (
    <svg
      width="762"
      height="498"
      viewBox="0 0 820 498"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text x="381" y="70" fontSize="14" fill="#FFFFFF99">
        {totalWidth}
      </text>
      <image x="-200" y="-100" width="1080" height="760" xlinkHref={LoveseatImage} />
      <g id="Group 1375">
        <g id="E-Comp">
          <g filter="url(#filter0_d_4403_7106)">
            <rect
              id="E-Background"
              x="752.399"
              y="47.2332"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(146.495 752.399 47.2332)"
              fill=""
            />
            <path
              id="E-Text"
              d="M728.657 45.8989V47.9556H721.845V45.8989H728.657ZM722.707 35.1587V47.9556H720.07V35.1587H722.707ZM727.769 40.3706V42.3745H721.845V40.3706H727.769ZM728.648 35.1587V37.2241H721.845V35.1587H728.648Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="E-Line"
            d="M701.491 74.2339C701.761 74.2889 702.025 74.1141 702.08 73.8435L702.977 69.4338C703.032 69.1632 702.857 68.8992 702.587 68.8442C702.316 68.7892 702.052 68.9639 701.997 69.2345L701.2 73.1543L697.28 72.3572C697.01 72.3021 696.746 72.4769 696.691 72.7475C696.636 73.0181 696.81 73.2821 697.081 73.3371L701.491 74.2339ZM685.617 48.9745C685.346 48.9195 685.082 49.0943 685.027 49.3649L684.13 53.7746C684.075 54.0452 684.25 54.3092 684.521 54.3642C684.791 54.4192 685.055 54.2445 685.11 53.9739L685.907 50.0541L689.827 50.8512C690.098 50.9063 690.362 50.7315 690.417 50.4609C690.472 50.1903 690.297 49.9263 690.026 49.8713L685.617 48.9745ZM702.007 73.4679L700.668 71.4446L699.834 71.9966L701.173 74.0199L702.007 73.4679ZM697.989 67.398L695.31 63.3515L694.476 63.9035L697.155 67.9501L697.989 67.398ZM692.631 59.3049L689.952 55.2583L689.118 55.8104L691.797 59.8569L692.631 59.3049ZM687.273 51.2118L685.934 49.1885L685.1 49.7405L686.44 51.7638L687.273 51.2118Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="D-Comp">
          <g filter="url(#filter1_d_4403_7106)">
            <rect
              id="D-Background"
              x="29.6162"
              y="189.163"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-1.30105 29.6162 189.163)"
              fill=""
            />
            <path
              id="D-Text"
              d="M49.7939 215.692H47.0078L47.0254 213.636H49.7939C50.4854 213.636 51.0684 213.48 51.543 213.17C52.0176 212.854 52.375 212.394 52.6152 211.79C52.8613 211.187 52.9844 210.457 52.9844 209.602V208.978C52.9844 208.321 52.9141 207.744 52.7734 207.246C52.6387 206.748 52.4365 206.329 52.167 205.989C51.8975 205.649 51.5664 205.395 51.1738 205.225C50.7812 205.049 50.3301 204.961 49.8203 204.961H46.9551V202.896H49.8203C50.6758 202.896 51.458 203.042 52.167 203.335C52.8818 203.622 53.5 204.035 54.0215 204.574C54.543 205.113 54.9443 205.758 55.2256 206.508C55.5127 207.252 55.6562 208.081 55.6562 208.995V209.602C55.6562 210.51 55.5127 211.339 55.2256 212.089C54.9443 212.839 54.543 213.483 54.0215 214.022C53.5059 214.556 52.8877 214.969 52.167 215.262C51.4521 215.549 50.6611 215.692 49.7939 215.692ZM48.502 202.896V215.692H45.8652V202.896H48.502Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="D-Line"
            d="M86.322 159.99C86.1224 159.8 85.8059 159.807 85.6151 160.006L82.5062 163.26C82.3154 163.459 82.3226 163.776 82.5222 163.967C82.7219 164.157 83.0384 164.15 83.2291 163.951L85.9926 161.059L88.8845 163.822C89.0842 164.013 89.4007 164.006 89.5915 163.806C89.7822 163.607 89.7751 163.29 89.5754 163.099L86.322 159.99ZM87.812 256.737C88.0116 256.928 88.3281 256.92 88.5189 256.721L91.6278 253.467C91.8186 253.268 91.8114 252.951 91.6117 252.76C91.4121 252.57 91.0956 252.577 90.9048 252.777L88.1413 255.668L85.2494 252.905C85.0498 252.714 84.7333 252.721 84.5425 252.921C84.3517 253.121 84.3589 253.437 84.5586 253.628L87.812 256.737ZM85.4767 160.363L85.5312 162.764L86.531 162.741L86.4764 160.34L85.4767 160.363ZM85.6403 167.565L85.7493 172.366L86.749 172.343L86.64 167.542L85.6403 167.565ZM85.8583 177.167L85.9674 181.968L86.9671 181.946L86.8581 177.145L85.8583 177.167ZM86.0764 186.77L86.1855 191.571L87.1852 191.548L87.0762 186.747L86.0764 186.77ZM86.2945 196.372L86.4035 201.173L87.4033 201.15L87.2942 196.349L86.2945 196.372ZM86.5126 205.974L86.6216 210.776L87.6214 210.753L87.5123 205.952L86.5126 205.974ZM86.7307 215.577L86.8397 220.378L87.8395 220.355L87.7304 215.554L86.7307 215.577ZM86.9488 225.179L87.0578 229.98L88.0575 229.958L87.9485 225.156L86.9488 225.179ZM87.1668 234.781L87.2759 239.583L88.2756 239.56L88.1666 234.759L87.1668 234.781ZM87.3849 244.384L87.494 249.185L88.4937 249.162L88.3847 244.361L87.3849 244.384ZM87.603 253.986L87.6575 256.387L88.6573 256.364L88.6028 253.963L87.603 253.986Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="C-Comp">
          <g filter="url(#filter2_d_4403_7106)">
            <rect
              id="C-Background"
              x="52.4312"
              y="369.239"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-22.6637 52.4312 369.239)"
              fill=""
            />
            <path
              id="C-Text"
              d="M81.9189 382.511H84.5469C84.4941 383.373 84.2568 384.137 83.835 384.805C83.4189 385.473 82.8359 385.995 82.0859 386.37C81.3418 386.745 80.4453 386.932 79.3965 386.932C78.5762 386.932 77.8408 386.792 77.1904 386.51C76.54 386.223 75.9834 385.813 75.5205 385.28C75.0635 384.747 74.7148 384.102 74.4746 383.346C74.2344 382.591 74.1143 381.744 74.1143 380.806V379.919C74.1143 378.981 74.2373 378.135 74.4834 377.379C74.7354 376.617 75.0928 375.969 75.5557 375.436C76.0244 374.903 76.584 374.493 77.2344 374.206C77.8848 373.919 78.6113 373.775 79.4141 373.775C80.4805 373.775 81.3799 373.969 82.1123 374.355C82.8506 374.742 83.4219 375.275 83.8262 375.955C84.2363 376.635 84.4824 377.408 84.5645 378.275H81.9277C81.8984 377.76 81.7959 377.323 81.6201 376.966C81.4443 376.602 81.1777 376.33 80.8203 376.148C80.4688 375.961 80 375.867 79.4141 375.867C78.9746 375.867 78.5908 375.949 78.2627 376.113C77.9346 376.277 77.6592 376.526 77.4365 376.86C77.2139 377.194 77.0469 377.616 76.9355 378.126C76.8301 378.63 76.7773 379.221 76.7773 379.901V380.806C76.7773 381.469 76.8271 382.052 76.9268 382.555C77.0264 383.053 77.1787 383.475 77.3838 383.821C77.5947 384.161 77.8643 384.419 78.1924 384.594C78.5264 384.764 78.9277 384.849 79.3965 384.849C79.9473 384.849 80.4014 384.761 80.7588 384.586C81.1162 384.41 81.3887 384.149 81.5762 383.803C81.7695 383.458 81.8838 383.027 81.9189 382.511Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="C-Line"
            d="M90.7887 312.253C90.5332 312.148 90.2411 312.27 90.1361 312.525L88.426 316.688C88.321 316.943 88.443 317.235 88.6984 317.34C88.9538 317.445 89.246 317.323 89.3509 317.068L90.8711 313.368L94.571 314.888C94.8264 314.993 95.1185 314.871 95.2235 314.616C95.3284 314.36 95.2064 314.068 94.951 313.963L90.7887 312.253ZM135.069 420.132C135.324 420.236 135.616 420.114 135.721 419.859L137.431 415.697C137.536 415.441 137.414 415.149 137.159 415.044C136.903 414.939 136.611 415.061 136.506 415.317L134.986 419.017L131.286 417.496C131.031 417.391 130.739 417.513 130.634 417.769C130.529 418.024 130.651 418.316 130.906 418.421L135.069 420.132ZM90.1372 312.908L91.0677 315.136L91.9904 314.751L91.06 312.523L90.1372 312.908ZM92.9285 319.593L94.7893 324.049L95.7121 323.664L93.8513 319.207L92.9285 319.593ZM96.6502 328.505L98.511 332.962L99.4338 332.576L97.5729 328.12L96.6502 328.505ZM100.372 337.418L102.233 341.875L103.155 341.489L101.295 337.033L100.372 337.418ZM104.093 346.331L105.954 350.787L106.877 350.402L105.016 345.946L104.093 346.331ZM107.815 355.244L109.676 359.7L110.599 359.315L108.738 354.859L107.815 355.244ZM111.537 364.157L113.398 368.613L114.32 368.228L112.46 363.771L111.537 364.157ZM115.259 373.069L117.119 377.526L118.042 377.141L116.181 372.684L115.259 373.069ZM118.98 381.982L120.841 386.439L121.764 386.053L119.903 381.597L118.98 381.982ZM122.702 390.895L124.563 395.351L125.485 394.966L123.625 390.51L122.702 390.895ZM126.424 399.808L128.284 404.264L129.207 403.879L127.346 399.423L126.424 399.808ZM130.145 408.721L132.006 413.177L132.929 412.792L131.068 408.335L130.145 408.721ZM133.867 417.633L134.797 419.862L135.72 419.476L134.79 417.248L133.867 417.633Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="B-Comp">
          <g filter="url(#filter3_d_4403_7106)">
            <rect
              id="B-Background"
              x="428.836"
              y="451.214"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 428.836 451.214)"
              fill=""
            />
            <path
              id="B-Text"
              d="M445.63 428.193L442.343 428.162L442.343 426.351L445.103 426.378C445.589 426.382 445.988 426.324 446.3 426.204C446.611 426.078 446.845 425.896 446.999 425.657C447.16 425.413 447.242 425.115 447.245 424.763C447.249 424.365 447.176 424.042 447.026 423.794C446.881 423.547 446.652 423.366 446.336 423.251C446.027 423.137 445.626 423.078 445.134 423.073L443.306 423.056L443.204 433.787L440.568 433.762L440.689 420.965L445.154 421.008C445.898 421.015 446.562 421.091 447.147 421.238C447.737 421.384 448.236 421.602 448.643 421.893C449.051 422.184 449.361 422.551 449.573 422.992C449.786 423.428 449.89 423.944 449.884 424.542C449.879 425.069 449.754 425.554 449.51 425.997C449.271 426.441 448.896 426.8 448.383 427.077C447.877 427.353 447.216 427.502 446.401 427.524L445.63 428.193ZM445.463 433.808L441.569 433.771L442.617 431.724L445.482 431.752C445.945 431.756 446.324 431.686 446.618 431.543C446.913 431.393 447.131 431.19 447.274 430.934C447.417 430.677 447.491 430.382 447.494 430.048C447.497 429.673 447.436 429.347 447.31 429.071C447.189 428.794 446.992 428.581 446.718 428.432C446.444 428.277 446.081 428.198 445.63 428.193L443.09 428.169L443.125 426.359L446.289 426.389L446.889 427.106C447.668 427.102 448.294 427.246 448.766 427.537C449.243 427.823 449.589 428.193 449.801 428.646C450.019 429.099 450.126 429.584 450.121 430.099C450.113 430.919 449.928 431.609 449.566 432.168C449.203 432.721 448.674 433.135 447.98 433.41C447.292 433.685 446.453 433.817 445.463 433.808Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M171.253 440.866C171.097 441.093 171.155 441.405 171.382 441.561L175.093 444.106C175.321 444.262 175.632 444.204 175.788 443.977C175.945 443.749 175.887 443.438 175.659 443.281L172.36 441.019L174.623 437.72C174.779 437.493 174.721 437.181 174.493 437.025C174.265 436.869 173.954 436.927 173.798 437.155L171.253 440.866ZM705.845 341.981C706.001 341.753 705.943 341.442 705.716 341.285L702.005 338.74C701.777 338.584 701.466 338.642 701.31 338.87C701.153 339.097 701.211 339.409 701.439 339.565L704.738 341.827L702.475 345.126C702.319 345.354 702.377 345.665 702.605 345.821C702.833 345.977 703.144 345.919 703.3 345.692L705.845 341.981ZM171.757 441.64L174.228 441.18L174.045 440.196L171.573 440.657L171.757 441.64ZM179.17 440.259L184.112 439.338L183.929 438.355L178.987 439.276L179.17 440.259ZM189.055 438.417L193.997 437.496L193.814 436.513L188.871 437.434L189.055 438.417ZM198.939 436.575L203.882 435.655L203.698 434.671L198.756 435.592L198.939 436.575ZM208.824 434.734L213.766 433.813L213.583 432.83L208.641 433.751L208.824 434.734ZM218.708 432.892L223.651 431.971L223.468 430.988L218.525 431.909L218.708 432.892ZM228.593 431.05L233.535 430.129L233.352 429.146L228.41 430.067L228.593 431.05ZM238.478 429.209L243.42 428.288L243.237 427.305L238.294 428.226L238.478 429.209ZM248.362 427.367L253.304 426.446L253.121 425.463L248.179 426.384L248.362 427.367ZM258.247 425.525L263.189 424.604L263.006 423.621L258.064 424.542L258.247 425.525ZM268.131 423.684L273.074 422.763L272.891 421.78L267.948 422.701L268.131 423.684ZM278.016 421.842L282.958 420.921L282.775 419.938L277.833 420.859L278.016 421.842ZM287.901 420L292.843 419.079L292.66 418.096L287.717 419.017L287.901 420ZM297.785 418.159L302.727 417.238L302.544 416.255L297.602 417.175L297.785 418.159ZM307.67 416.317L312.612 415.396L312.429 414.413L307.487 415.334L307.67 416.317ZM317.554 414.475L322.497 413.554L322.313 412.571L317.371 413.492L317.554 414.475ZM327.439 412.634L332.381 411.713L332.198 410.73L327.256 411.65L327.439 412.634ZM337.323 410.792L342.266 409.871L342.083 408.888L337.14 409.809L337.323 410.792ZM347.208 408.95L352.15 408.029L351.967 407.046L347.025 407.967L347.208 408.95ZM357.093 407.108L362.035 406.188L361.852 405.205L356.909 406.125L357.093 407.108ZM366.977 405.267L371.92 404.346L371.736 403.363L366.794 404.284L366.977 405.267ZM376.862 403.425L381.804 402.504L381.621 401.521L376.679 402.442L376.862 403.425ZM386.746 401.583L391.689 400.663L391.506 399.68L386.563 400.6L386.746 401.583ZM396.631 399.742L401.573 398.821L401.39 397.838L396.448 398.759L396.631 399.742ZM406.516 397.9L411.458 396.979L411.275 395.996L406.332 396.917L406.516 397.9ZM416.4 396.058L421.342 395.138L421.159 394.154L416.217 395.075L416.4 396.058ZM426.285 394.217L431.227 393.296L431.044 392.313L426.102 393.234L426.285 394.217ZM436.169 392.375L441.112 391.454L440.928 390.471L435.986 391.392L436.169 392.375ZM446.054 390.533L450.996 389.613L450.813 388.629L445.871 389.55L446.054 390.533ZM455.938 388.692L460.881 387.771L460.698 386.788L455.755 387.709L455.938 388.692ZM465.823 386.85L470.765 385.929L470.582 384.946L465.64 385.867L465.823 386.85ZM475.708 385.008L480.65 384.087L480.467 383.104L475.524 384.025L475.708 385.008ZM485.592 383.167L490.535 382.246L490.351 381.263L485.409 382.184L485.592 383.167ZM495.477 381.325L500.419 380.404L500.236 379.421L495.294 380.342L495.477 381.325ZM505.361 379.483L510.304 378.562L510.121 377.579L505.178 378.5L505.361 379.483ZM515.246 377.642L520.188 376.721L520.005 375.738L515.063 376.659L515.246 377.642ZM525.131 375.8L530.073 374.879L529.89 373.896L524.947 374.817L525.131 375.8ZM535.015 373.958L539.957 373.037L539.774 372.054L534.832 372.975L535.015 373.958ZM544.9 372.117L549.842 371.196L549.659 370.213L544.717 371.134L544.9 372.117ZM554.784 370.275L559.727 369.354L559.543 368.371L554.601 369.292L554.784 370.275ZM564.669 368.433L569.611 367.512L569.428 366.529L564.486 367.45L564.669 368.433ZM574.553 366.592L579.496 365.671L579.313 364.688L574.37 365.608L574.553 366.592ZM584.438 364.75L589.38 363.829L589.197 362.846L584.255 363.767L584.438 364.75ZM594.323 362.908L599.265 361.987L599.082 361.004L594.139 361.925L594.323 362.908ZM604.207 361.067L609.15 360.146L608.966 359.163L604.024 360.083L604.207 361.067ZM614.092 359.225L619.034 358.304L618.851 357.321L613.909 358.242L614.092 359.225ZM623.976 357.383L628.919 356.462L628.736 355.479L623.793 356.4L623.976 357.383ZM633.861 355.541L638.803 354.621L638.62 353.638L633.678 354.558L633.861 355.541ZM643.746 353.7L648.688 352.779L648.505 351.796L643.562 352.717L643.746 353.7ZM653.63 351.858L658.572 350.937L658.389 349.954L653.447 350.875L653.63 351.858ZM663.515 350.016L668.457 349.096L668.274 348.113L663.332 349.033L663.515 350.016ZM673.399 348.175L678.342 347.254L678.158 346.271L673.216 347.192L673.399 348.175ZM683.284 346.333L688.226 345.412L688.043 344.429L683.101 345.35L683.284 346.333ZM693.168 344.491L698.111 343.571L697.928 342.587L692.985 343.508L693.168 344.491ZM703.053 342.65L705.525 342.189L705.341 341.206L702.87 341.667L703.053 342.65Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter4_d_4403_7106)">
            <rect
              id="A-Background"
              x="787.163"
              y="320.189"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-174.18 787.163 320.189)"
              fill=""
            />
            <path
              id="A-Text"
              d="M769.146 293.608L765.666 304.217H762.862L767.617 291.42H769.401L769.146 293.608ZM772.038 304.217L768.549 293.608L768.268 291.42H770.069L774.851 304.217H772.038ZM771.88 299.453V301.518H765.121V299.453H771.88Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M730.143 314C730.317 314.214 730.632 314.246 730.846 314.072L734.334 311.229C734.548 311.055 734.581 310.74 734.406 310.526C734.232 310.311 733.917 310.279 733.703 310.454L730.602 312.981L728.075 309.88C727.9 309.666 727.586 309.634 727.371 309.809C727.157 309.983 727.125 310.298 727.3 310.512L730.143 314ZM734.928 274.03C734.753 273.816 734.438 273.784 734.224 273.959L730.736 276.801C730.522 276.976 730.49 277.291 730.664 277.505C730.839 277.719 731.154 277.751 731.368 277.577L734.468 275.05L736.995 278.15C737.17 278.364 737.485 278.396 737.699 278.222C737.913 278.047 737.945 277.733 737.77 277.518L734.928 274.03ZM731.028 313.735L731.278 311.276L730.283 311.175L730.033 313.634L731.028 313.735ZM731.78 306.359L732.281 301.442L731.286 301.34L730.785 306.258L731.78 306.359ZM732.782 296.525L733.283 291.607L732.288 291.506L731.787 296.423L732.782 296.525ZM733.784 286.69L734.286 281.773L733.291 281.671L732.79 286.589L733.784 286.69ZM734.787 276.855L735.037 274.397L734.043 274.295L733.792 276.754L734.787 276.855Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_4403_7106"
          x="665.579"
          y="-6.9541"
          width="116.82"
          height="116.82"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4403_7106" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4403_7106"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_4403_7106"
          x="-0.383789"
          y="168.232"
          width="101.92"
          height="101.92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4403_7106" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4403_7106"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_4403_7106"
          x="22.4312"
          y="333.44"
          width="113.632"
          height="113.632"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4403_7106" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4403_7106"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_4403_7106"
          x="391.327"
          y="383.397"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4403_7106" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4403_7106"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_4403_7106"
          x="716.374"
          y="255.243"
          width="104.946"
          height="104.946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4403_7106" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4403_7106"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default TwoSeatOneBack
